import { Stack } from '@mui/material';
import { Button, Typography, colors } from '@sweep-io/sweep-design';

type ArtifactsTab = 'shared' | 'my-artifacts';

interface ArtifactsEmptyStateProps {
  isFiltered: boolean;
  activeTab: ArtifactsTab;
  onCreateClick: () => void;
}

const getEmptyStateContent = (isFiltered: boolean, activeTab: ArtifactsTab) => {
  if (isFiltered) {
    return {
      title: 'No results found',
      subtitle: 'Try changing your filters or search term',
      showButton: false,
    };
  }

  if (activeTab === 'shared') {
    return {
      title: 'No shared artifacts yet',
      subtitle: 'Artifacts shared with your team will appear here',
      showButton: false,
    };
  }

  return {
    title: 'No artifacts yet.',
    subtitle: 'Click below to create your first one',
    showButton: true,
  };
};

export const ArtifactsEmptyState = ({
  isFiltered,
  activeTab,
  onCreateClick,
}: ArtifactsEmptyStateProps) => {
  const { title, subtitle, showButton } = getEmptyStateContent(isFiltered, activeTab);

  return (
    <Stack height="100%" justifyContent="center" alignItems="center" gap={2}>
      <Typography variant="h3-medium" color={colors.grey[800]}>
        {title}
      </Typography>
      <Typography variant="body" color={colors.grey[700]}>
        {subtitle}
      </Typography>
      {showButton && (
        <Button startIconName="Plus" size="small" onClick={onCreateClick}>
          Create Your First Artifact
        </Button>
      )}
    </Stack>
  );
};
